<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Numeral';
                }
            },
            hardwareColour: {
                required: true
            },
            numeralColour: {
                required: false,
                default(){
                    return 0;
                }
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            hardwareSuite: {
                required: false,
                default(){
                    return '';
                }
            },
            typeRange: {
                required: false,
                default(){
                    return '';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareColour, this.hardwareHandle, this.slab, this.typeRange, this.numeralColour);
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-numeral?hardware_colour=' + this.hardwareColour
                        + '&hardware_handle=' + this.hardwareHandle
                        + '&slab=' + this.slab
                        + '&suite=' + this.hardwareSuite
                        + '&type_range=' + this.typeRange
                        + '&numeral_colour=' + this.numeralColour;
            },
            cache_key(){
                return '_' + this.hardwareSuite + '_' + this.hardwareColour + '_' + this.hardwareHandle + '_' + this.slab + '_' + this.typeRange + '_' + this.numeralColour;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
